<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    fill="currentColor"
    viewBox="0 0 16 16"
    class="calendar-event-outline-icon"
    :style="{ '--icon-color': color }"
  >
    <title v-if="tooltip">{{ tooltip }}</title>
    <path d="M11 6.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5z" />
    <path
      d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z"
    />
  </svg>
</template>

<script setup>
defineProps({
  size: {
    type: [String, Number],
    default: 16,
  },
  color: {
    type: String,
    default: '#6b7280',
  },
  tooltip: {
    type: String,
    default: '',
  },
})
</script>

<style scoped>
.calendar-event-outline-icon {
  display: inline-block;
  vertical-align: middle;
  color: var(--icon-color, #6b7280);
}
</style>
